import { apiInstances } from '../../../../../libs';

const { post } = apiInstances.orderInstance;

export default function toReceiveCrossdockingFromWarecloud({
  scanValue,
  scanFromBarcode = true,
}) {
  return post(`/orders/${scanValue}/crossdocking/process-package`, {
    metadata: {
      scanFromBarcode,
    },
  });
}
